import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useAuth, useLanguage, API } from '@/App';
import { getTranslation } from '@/translations';

// Menangani fragment #gcode= (kode sekali-pakai) dari redirect Google OAuth.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const GoogleAuthCallback = () => {
  const { exchangeGoogleCode } = useAuth();
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const code = params.get('gcode');

    (async () => {
      try {
        const data = await exchangeGoogleCode(code);
        let target = '/dashboard';
        try {
          const res = await axios.get(`${API}/onboarding/status`, {
            headers: { Authorization: `Bearer ${data.token}` }
          });
          target = res.data?.completed ? '/dashboard' : '/onboarding';
        } catch (e) {
          target = '/dashboard';
        }
        window.location.replace(target);
      } catch (e) {
        setError(t('auth.googleLoginFailed'));
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-[#0A0A0A] px-6">
      {error ? (
        <div className="max-w-sm text-center" data-testid="google-auth-error">
          <p className="text-slate-900 dark:text-zinc-50 font-medium mb-2">{error}</p>
          <a href="/login" className="text-indigo-600 dark:text-indigo-400 hover:underline" data-testid="google-auth-back-login">
            {t('auth.login')}
          </a>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-4" data-testid="google-auth-loading">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600" />
          <p className="text-slate-600 dark:text-zinc-400">{t('auth.connectingGoogle')}</p>
        </div>
      )}
    </div>
  );
};

export default GoogleAuthCallback;
